import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from '../../../../localization/useTranslation';
import T from '../../../../localization/LocalizationKeys';
import _ from 'lodash';
import ModelType from '../../../Model/ModelType';
import ContentBindingTable from '../utils/ContentBindingTable';
import { getTelemetry } from '../../../../utils/dtdl';

const columns = [
  {
    label: T.model.binding.target,
    path: 'contentId',
    searchItem: true,
    isSortable: true
  },
  {
    label: T.model.displayName,
    path: 'displayName',
    searchItem: true,
    isSortable: true
  },
  {
    label: T.model.binding.sourceModel,
    path: 'sourceModel',
    searchItem: true,
    isSortable: true,
    render: (model) => {
      return model?.displayName;
    }
  },
  {
    label: T.model.binding.source,
    path: 'source',
    searchItem: true,
    isSortable: true,
    render: (model) => {
      return model?.displayName;
    }
  },
  {
    label: T.model.binding.transform,
    path: 'transforms',
    searchItem: true,
    isSortable: true
  },
  {
    label: T.model.description,
    path: 'description',
    searchItem: true
  },
  {
    label: T.model.comment,
    path: 'comment',
    searchItem: true
  }
];


export const TelemetryTab = ({ telemetryBindings, onUpdate, sourceMap }) => {
  const T = useTranslation();
  const [content, setContent] = useState({});

  const sourceModelOptions = useMemo(() => {
    return _.map(sourceMap, value => ({ value, text: value.displayName }));
  }, [sourceMap]);

  const sourceTelemetryOptions = useMemo(() => {
    if (!_.isEmpty(content?.sourceModel)) {
      return _.map(getTelemetry({ dtdlModel: content?.sourceModel }), value => ({ value, text: value.displayName }));
    }
    return [];

  }, [content?.sourceModel]);

  const bindingModel = useMemo(() => {
    return [
      {
        type: ModelType.TEXT,
        label: T.model.name,
        path: 'contentId',
        isRequired: true
      },
      {
        type: ModelType.TEXT,
        label: T.model.displayName,
        path: 'displayName',
        isRequired: true,
        hasError: _.isEmpty
      },
      {
        type: ModelType.OPTIONSV2,
        label: T.model.binding.sourceModel,
        path: 'sourceModel',
        isRequired: true,
        hasError: _.isEmpty,
        options: sourceModelOptions,
        properties: {
          iteratee: _.iteratee('@id')
        }
      },
      {
        type: ModelType.OPTIONSV2,
        label: T.model.binding.source,
        path: 'source',
        isRequired: true,
        hasError: _.isEmpty,
        options: sourceTelemetryOptions,
        properties: {
          iteratee: _.iteratee('@id'),
          isTypeahead: true
        }
      },
      {
        type: ModelType.TEXT,
        label: T.model.description,
        path: 'description',
        isRequired: false
      },
      {
        type: ModelType.TEXT,
        label: T.model.comment,
        path: 'comment'
      }
    ];
  }, [T.model.binding.source, T.model.binding.sourceModel, T.model.comment, T.model.description, T.model.displayName, T.model.name, sourceModelOptions, sourceTelemetryOptions]);

  const onSave = useCallback((content) => {
    onUpdate(content);
  }, [onUpdate]);
  return (
    <>
      <ContentBindingTable
        title={T.model.tab.telemetry}
        columns={columns}
        data={telemetryBindings}
        dialogModel={bindingModel}
        updatedContent={setContent}
        onSave={onSave}
        globalActions={[]}
      />
    </>
  );
};
